module.exports = __webpack_public_path__ + "img/introdute.f4c5ade4.png";